// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__257QB","top":"styles_top__1BfEJ","left":"styles_left__3TArh","description":"styles_description__352C1"};